import { DOCUMENT, inject, InjectionToken } from '@angular/core';
import { isServer } from '../utilities/platform-type';

// mimic the breakpoints we configured in tailwind
export const screenSizes = [
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  '2xl',
  '3xl',
  '4xl',
  '5xl',
  '6xl',
  '7xl',
  '8xl',
  '9xl',
  '10xl'
] as const;
export type ScreenSize = typeof screenSizes[number];

export const TW_BREAKPOINTS = new InjectionToken<Record<ScreenSize, string>>('TW_BREAKPOINTS', {
  providedIn: 'root',
  factory: () => {
    const document = inject(DOCUMENT);

    if (isServer())
      return {} as Record<ScreenSize, string>;

    const styles = getComputedStyle(document.documentElement);

    const breakpoints = screenSizes.reduce((state, current) => {
      const container = styles.getPropertyValue(`--breakpoint-${current}`);
      if (container) {
        state[current] = container;
      }
      return state;
    }, {} as Record<ScreenSize, string>);

    return breakpoints;
  }
});

export const BREAKPOINTS_PX = new InjectionToken('BREAKPOINTS_PX', {
  providedIn: 'root',
  factory: () => {
    const document = inject(DOCUMENT);
    const breakpoints = inject(TW_BREAKPOINTS);

    // Get the actual computed font size from the root element
    const rootFontSize = isServer() ?
      16 :
      parseFloat(getComputedStyle(document.documentElement).fontSize);


    const pixelMap = {} as Record<ScreenSize, number>;

    for (const [key, remValue] of Object.entries(breakpoints)) {
      const remNum = parseFloat(remValue);
      pixelMap[key as ScreenSize] = remNum * rootFontSize;
    }

    return {
      ...pixelMap,
      remToPixels: (rem: number) => rem * rootFontSize
    };
  }
});
